import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const ResetPasswordPage = lazy(() => import('./ResetPasswordPage'));

const ResetPasswordPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'reset/:token/:email',
      element: <ResetPasswordPage />,
    },
  ],
};

export default ResetPasswordPageConfig;
